import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { formatDistanceToNow } from 'date-fns';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import { MaterialReactTable } from 'material-react-table';
import Swal from 'sweetalert2';
import PropTypes from 'prop-types';

import {
  MenuItem,
} from '@mui/material';

const ViewAllRawMaterialPricingSupplierGroupBy = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});


  useEffect(() => {
    const fetchData = () => {
      const season_id = localStorage.getItem("season_id");
      axios
        .get(`/raw-materials/raw-material-pricing-supplier-groupby/${id + '_' + season_id}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            setValue(response.data.data.supplier);
            setData(response.data.data.materials);

            console.log(response.data.data.materials);
          }
        })
        .catch((error) => {
          console.log(error);
        })
    };

    setPermission(FindModuleById(191));

    // Initial fetch
    fetchData();

    // Use both visibilitychange and focus events for better coverage
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        console.log("Tab visible - refetching");
        fetchData();
      }
    };

    const handleFocus = () => {
      console.log("Window focused - refetching");
      fetchData();
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleFocus);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleFocus);
    };
  }, [id]);

  // useEffect(() => {
  //       setPermission(FindModuleById(191)); 
  //     console.log(permission);


  //   axios
  //     .get(`/raw-materials/raw-material-pricing-supplier-groupby/${id}`, {
  //       headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
  //     })
  //     .then((response) => {
  //       if (response.data.code === 200) {
  //         setValue(response.data.data.supplier);
  //         setData(response.data.data.materials);

  //         console.log(response.data.data.materials);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, [id]);




  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const viewItem = (item) => {
    window.location.href = "/raw-material-pricing-view/" + item;
  }
  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/raw-materials/delete/${item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              setTimeout(() => {
                window.location.href = "/raw-materials";
              }, 500);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }

  const CustomLotNumberCell = ({ row }) => {
    if (!row || !row.original) return null; // Prevents errors if row is undefined
    return permission && permission.update === 1 ? (
      <a href={`/raw-material-pricing-edit/${row.original.id}`}>
        {row.original.lot_number}
      </a>
    ) : (
      <span>{row.original.lot_number}</span>
    );
  };

  CustomLotNumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        lot_number: PropTypes.string,
      }),
    }),
  };

  const TotalNetWeightCell = ({ row }) => {
    const total_decay = row.original.palletesation || [];
    const totalNetWeight = total_decay
      .filter((item) => item.used === 1)
      .reduce((sum, item) => sum + (item.net_weight || 0), 0);
    return <span>{totalNetWeight.toFixed(2)} (KG)</span>;
  };

  TotalNetWeightCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        palletesation: PropTypes.arrayOf(
          PropTypes.shape({
            used: PropTypes.number,
            net_weight: PropTypes.number,
          })
        ),
      }),
    }),
  };



  const AmountCell = ({ row }) => {
    const total_decay = row.original.palletesation || [];
    const decay_netWeight = total_decay
      .filter((item) => item.used === 1 && item.type === 1)
      .reduce((sum, item) => sum + (item.net_weight || 0), 0);
    const decay_price = row.original.decay_price || 0;
    const price = row.original.price || 0;
    const bl_net_weight = row.original.net_weight || 0;
    const cost_paid_by_farmer = row.original.cost_paid_by_farmer || 0;
    const rebate = row.original.rebate || 0;

    const final_amount =
      (bl_net_weight - decay_netWeight) * (1 - rebate / 100) * price +
      decay_netWeight * (1 - rebate / 100) * decay_price -
      cost_paid_by_farmer;
    console.log(final_amount)
    const total_amount = row.original.total_amount || 0;
    return <span>{new Intl.NumberFormat().format(total_amount.toFixed(2))} (KG)</span>;
  };

  AmountCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        palletesation: PropTypes.arrayOf(
          PropTypes.shape({
            used: PropTypes.number,
            type: PropTypes.number,
            net_weight: PropTypes.number,
          })
        ),
        decay_price: PropTypes.number,
        price: PropTypes.number,
        net_weight: PropTypes.number,
        cost_paid_by_farmer: PropTypes.number,
        rebate: PropTypes.number,
        total_amount: PropTypes.number
      }),
    }),
  };
  const itemLotNumber = ({ row }) => {
    const calibreDisplay = row.original.palletesation
      ? [...new Set(row.original.palletesation.map((item) => item.productname))].join(' / ')
      : '';
    return <span>{calibreDisplay}</span>;
  };
  itemLotNumber.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        palletesation: PropTypes.arrayOf(
          PropTypes.shape({
            productname: PropTypes.string,
          })
        ),
      }).isRequired,
    }).isRequired,
  };
  const columns = [
    {
      header: "Lot Number",
      accessorFn: (row) => `${row.lot_number}`,
      Cell: CustomLotNumberCell,
    },
    {
      header: "Supplier",
      accessorFn: (row) => `${row.supplier_name ? row.supplier_name.name : ""}`,
    },
    {
      header: "Location",
      accessorFn: (row) =>
        `${row.location_name ? row.location_name.title : ""}`,
    },
    {
      header: 'Product',
      accessorFn: (row) => row.palletesation ? row.palletesation.map(item => item.productname).join(' / ') : '',
      Cell: itemLotNumber,
    },


    {
      accessorKey: 'note',
      header: 'Note',
    },

    {
      header: "Grade A Price",
      accessorFn: (row) =>
        parseFloat(row.grade_a_price).toFixed(2) +
        `${row.raw_currency ? row.raw_currency.symbol : ""}`,
    },

    //      {
    //   header: 'Grade A Net Weight',
    //   accessorFn: (row) => {
    //     const netWeight = row.grade_a_net_weight ?? 0; // Default to 0 if undefined or null
    //     return `${Number(netWeight).toFixed(2)} (KG)`;
    //   },
    // },
    {
      header: 'Grade A Net Weight',
      accessorFn: (row) => {
        let grade_a_net_weight = 0;
        if (row.id > 357) {
          grade_a_net_weight = row.grade_a_bl_weight;
        } else {
          grade_a_net_weight = row.grade_a_net_weight;
        }
        const netWeight = grade_a_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
    {
      header: "Grade B Price",
      accessorFn: (row) =>
        parseFloat(row.grade_b_price).toFixed(2) +
        `${row.raw_currency ? row.raw_currency.symbol : ""}`,
    },
    //    {
    //   header: 'Grade B Net Weight',
    //   accessorFn: (row) => {
    //     const netWeight = row.grade_b_net_weight ?? 0; // Default to 0 if undefined or null
    //     return `${Number(netWeight).toFixed(2)} (KG)`;
    //   },
    // },
    {
      header: 'Grade B Net Weight',
      accessorFn: (row) => {
        let grade_b_net_weight = 0;
        if (row.id > 357) {
          grade_b_net_weight = row.grade_b_bl_weight;
        } else {
          grade_b_net_weight = row.grade_b_net_weight;
        }

        const netWeight = grade_b_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
    {
      header: 'Amount',
      accessorFn: (row) => {
        const netWeight = row.total_amount ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (MAD)`;
      },
    },

    {
      header: 'Net Weight',
      accessorFn: (row) => {
        const netWeight = row.total_net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },


    // {
    //   header: "BL Net Weight",
    //   accessorFn: (row) =>
    //     `${(row.net_weight ?? 0).toFixed(2)} (KG)`,
    // },
    // {
    //   header: "BL Gross Weight",
    //   accessorFn: (row) =>
    //     `${(row.gross_weight ?? 0).toFixed(2)} (KG)`,
    // },

    // {
    //   header: "BL Gross Weight",
    //   accessorFn: (row) => `${row.gross_weight.toFixed(2)} (KG)`,
    // },
    {
      accessorKey: "driver_name",
      header: "Driver Name",
    },

    {
      accessorKey: "plate_number",
      header: "Plate Number",
    },

    {
      accessorKey: "shift_date",
      header: "Shift Date",
    },
    {
      header: "Farm",
      accessorFn: (row) => `${row.farmer_detail ? row.farmer_detail.name : ""}`,
    },

    {
      accessorKey: "date_time",
      header: "Date Time",
    },


    {
      header: "Created By",
      accessorFn: (row) =>
        `${row.createdby ? row.createdby.first_name + " " + row.createdby.last_name : ""}`,
    },
    {
      header: 'Created At',
      accessorFn: (row) =>
        formatDistanceToNow(new Date(row.created_at), { addSuffix: true }),
    },
    {
      header: "Updated By",
      accessorFn: (row) =>
        `${row.updatedby ? row.updatedby.first_name + " " + row.updatedby.last_name : ""}`,
    },
    {
      header: 'Updated At',
      accessorFn: (row) =>
        formatDistanceToNow(new Date(row.updated_at), { addSuffix: true }),
    },
  ];




  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material Pricing Group By Supplier</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/raw-material-pricing">Raw Material Pricing</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Raw Material Pricing Group By Supplier
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Raw Material Pricing Group By Supplier </h4>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">Name</th>
                        <td className="p-3">{value.name}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Supplier Type</th>
                        <td className="p-3">
                          {value.supply_type ? value.supply_type.title : ""}
                        </td>
                      </tr>

                    </table>
                  </div>
                </div>
              </div>
            </div>




            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Listing Raw Material Pricing</h4>
                    <div className="table-responsive">
                      <MaterialReactTable columns={columns} data={data}
                        enableColumnOrdering
                        enablePinning
                        enableRowActions
                        //renderColumnActionsMenuItems 
                        renderRowActionMenuItems={({ row }) => [
                          <MenuItem key="view" onClick={() => viewItem(row.original.id)}>
                            View
                          </MenuItem>,
                          <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                            Delete
                          </MenuItem>,
                        ]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>




          </div>
        </div>
      </div>
    </>
  );
};
export default ViewAllRawMaterialPricingSupplierGroupBy;
